import AgentPage from './agent-page';

export default AgentPage;
